import { render, staticRenderFns } from "./DailyRefreshAlert.vue?vue&type=template&id=20f10b34&"
import script from "./DailyRefreshAlert.vue?vue&type=script&lang=js&"
export * from "./DailyRefreshAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
